module.exports = __webpack_public_path__ + "static/img/factory.aef3244.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/factory.png
// module id = FUvW
// module chunks = 1